export default "__VITE_ASSET__6bc4b951__"